export default __webpack_public_path__ + "static/PromptIconFourTeen-72bcb0e7a49e70ac1f379fe18c71af25.png";